import type { AgentFilterListWidget, AgentWidget } from 'aevocam-rest-api-spec'
import { AgentFilterList } from './AgentFilterList'

type Props = {
  widget: AgentWidget
  fromStream?: boolean
  setArticleIds?: (articleIds?: string[]) => void
}

export function AgentWidgetView({ widget, fromStream, setArticleIds }: Props) {
  switch (widget.type) {
    case 'filterList':
      return (
        <AgentFilterList
          widget={widget as AgentFilterListWidget}
          fromStream={fromStream}
          setArticleIds={setArticleIds}
        />
      )
    default:
      return null
  }
}
